/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/no-autofocus */
import React, { useState, useRef } from 'react';
import { Card, CardContent, Typography, Button, IconButton, Box, TextField } from '@mui/material';
import { FiX, FiImage, FiFile, FiPlus, FiEdit3, FiTrash2 } from 'react-icons/fi';
import { RiUploadCloud2Line } from 'react-icons/ri';
import { useTheme } from '@mui/material/styles';
import axios from 'lib/axios';
import { Modal } from '@mui/material';

const Notice = ({ notice, isOpen, setOpenEditor, operation, showSnack, setReload, setNotices, setSelected }) => {
    const theme = useTheme();
    const imageInput = useRef(null);
    const textInput = useRef(null);
    const pdfInput = useRef(null);
    const audioInput = useRef(null);

    const handleClose = () => {
        setOpenEditor(false);
    };

    const [text, setText] = useState(notice ? notice.plain_text_body : '');
    const [title, setTitle] = useState(notice ? notice.notice_title : '');
    const [processing, setProcessing] = useState(false);
    const [openPdfUploader, setOpenPdfUploader] = useState(notice?.files != null ? true : false);
    const [openAudioUploader, setOpenAudioUploader] = useState(false);
    const [openImageUploader, setOpenImageUploader] = useState(
        (notice?.images && Array.isArray(notice.images) && notice.images.length > 0) ||
            (notice?.videos && Array.isArray(notice.videos) && notice.videos.length > 0) ||
            false
    );
    const [postImage, setPostImage] = useState(null);
    const [postImages, setPostImages] = useState([]);
    const [postMediaData, setPostMediaData] = useState([]);
    const [postMediaFile, setPostMediaFile] = useState([]);
    const [postPdfs, setPostPdfs] = useState([]);
    const [postPdfNames, setPostPdfNames] = useState([]);
    const [postPdfsData, setPostPdfsData] = useState([]);
    const getFileName = (file) => {
        if (!file || typeof file !== 'string') return file;
        return file.split('/').pop();
    };

    const [existingpostImages, setExistingPostImages] = useState(
        notice?.images && Array.isArray(notice.images) ? notice.images.map(getFileName) : []
    );
    const [existingpostVideos, setExistingPostVideos] = useState(notice?.videos && Array.isArray(notice.videos) ? notice.videos : []);
    const [existingFiles, setExistingFiles] = useState(
        notice?.attachments && Array.isArray(notice.attachments) ? notice.attachments.map(getFileName) : []
    );

    const [url, setUrl] = useState(() => {
        return notice ? '/notice/update' : '/notice';
    });

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    async function convertMedia() {
        Array.from(imageInput.current.files).forEach(async (f) => {
            if (f.size < 52453290) {
                const file = await toBase64(f);
                const url = URL.createObjectURL(f);
                setPostMediaData((postMediaData) => [...postMediaData, file]);
                setPostMediaFile((postMediaFile) => [...postMediaFile, f]);
                setPostImages((postImages) => [...postImages, url]);
            } else {
                alert('Size Must Be Smaller Than 50MB');
            }
        });
    }

    async function convertPdf() {
        Array.from(pdfInput.current.files).forEach(async (f) => {
            if (f.size < 52453290) {
                const file = f;
                const url = URL.createObjectURL(f);
                setPostPdfsData([...postPdfsData, file]);
                setPostPdfs([...postPdfs, url]);
                setPostPdfNames([...postPdfNames, f.name]);
            } else {
                alert('Size Must Be Smaller Than 50MB');
            }
        });
    }

    async function submitPost() {
        setProcessing(true);
        const formData = new FormData();
        formData.append('plain_text_body', text);
        formData.append('notice_title', title);
        formData.append('has_rich_content', true);
        formData.append('is_leader_voice', true);
        formData.append('company_id', JSON.parse(window.localStorage.getItem('authUser'))?.company_id);
        formData.append('old_images', JSON.stringify(existingpostImages));
        formData.append('old_videos', JSON.stringify(existingpostVideos));
        formData.append('old_files', JSON.stringify(existingFiles));
        formData.append('announce_date', new Date().getTime());

        if (notice) {
            formData.append('notice_id', notice.notice_id);
        }

        postMediaFile.forEach((media, index) => {
            formData.append(`media-${index}`, media);
        });
        postPdfsData.forEach((pdf, index) => {
            formData.append(`docs-${index}`, pdf);
        });

        await axios
            .post(`${url}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(({ data }) => {
                if (data.success) {
                    if (notice) {
                        setNotices((prev) => {
                            return [
                                ...prev.map((item) => {
                                    if (item.notice_id == notice.notice_id) {
                                        item = data.notice;
                                        return item;
                                    } else {
                                        return item;
                                    }
                                })
                            ];
                        });
                    } else {
                        setNotices((prev) => {
                            return [data.notice, ...prev];
                        });
                    }

                    setOpenEditor(false);
                    setPostMediaData([]);
                    setPostPdfsData([]);
                    setPostPdfNames([]);
                    setPostPdfs([]);
                    setPostImages([]);
                    setText('');
                    if (showSnack) {
                        showSnack(false, `${data.message}`);
                    }
                    if (setReload) {
                        setReload(true);
                    }
                }
            })
            .catch((err) => console.log(err));
    }

    async function destroyNotice() {
        setProcessing(true);
        await axios
            .post(`/notice/destroy`, { notice_id: notice.notice_id })
            .then(({ data }) => {
                if (data.success) {
                    setProcessing(false);
                    setNotices((prev) => {
                        return [
                            ...prev.filter((item) => {
                                if (item.notice_id != notice.notice_id) {
                                    return item;
                                }
                            })
                        ];
                    });
                    setOpenEditor(false);
                }
            })
            .catch((err) => {
                setProcessing(false);
                console.log(err);
            });
    }

    if (!isOpen) return null;

    return (
        <Modal open={isOpen} onClose={handleClose}>
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 1000
                }}
            >
                {operation === 'create' || operation === 'update' ? (
                    <Card
                        sx={{
                            width: { xs: '95%', md: '700px' },
                            maxHeight: '90vh',
                            position: 'relative',
                            borderRadius: '12px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                            backgroundColor: 'white'
                        }}
                    >
                        <CardContent
                            sx={{
                                p: 3,
                                maxHeight: '85vh',
                                overflowY: 'auto',
                                '&::-webkit-scrollbar': {
                                    display: 'none'
                                },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none'
                            }}
                        >
                            {/* Header */}
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <FiEdit3 size={20} color={theme.palette.primary.main} />
                                    <Typography color="primary" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                                        {notice ? 'Edit' : 'Create'} Notice
                                    </Typography>
                                </Box>
                                <IconButton
                                    onClick={handleClose}
                                    sx={{
                                        color: 'text.secondary',
                                        bgcolor: 'grey.100',
                                        borderRadius: '50%',
                                        '&:hover': { bgcolor: 'grey.300' }
                                    }}
                                >
                                    <FiX size={18} />
                                </IconButton>
                            </Box>

                            {/* Title Input */}
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                    Title
                                </Typography>
                                <TextField
                                    fullWidth
                                    placeholder="Enter notice title..."
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px',
                                            backgroundColor: '#F8FAFC'
                                        }
                                    }}
                                />
                            </Box>

                            {/* Description Input */}
                            <Box sx={{ mb: 3, position: 'relative' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                    Description
                                </Typography>
                                <textarea
                                    ref={textInput}
                                    placeholder="Write your notice description..."
                                    value={text}
                                    onChange={(e) => setText(e.target.value)}
                                    style={{
                                        width: '100%',
                                        minHeight: '120px',
                                        padding: '16px',
                                        border: '1px solid #E2E8F0',
                                        borderRadius: '8px',
                                        resize: 'vertical',
                                        fontFamily: 'inherit',
                                        fontSize: '1rem',
                                        background: '#F8FAFC',
                                        outline: 'none'
                                    }}
                                />
                            </Box>

                            {/* Media Options */}
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                                    Add to your notice
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                    <Button
                                        variant={openImageUploader ? 'contained' : 'outlined'}
                                        startIcon={<FiImage size={16} />}
                                        onClick={() => {
                                            setOpenImageUploader(!openImageUploader);
                                            setOpenPdfUploader(false);
                                            if (!openImageUploader && !postImages.length) {
                                                setTimeout(() => imageInput.current?.click(), 100);
                                            }
                                        }}
                                        sx={{
                                            textTransform: 'none',
                                            fontSize: '0.875rem',
                                            borderRadius: '8px'
                                        }}
                                    >
                                        Photos/Videos
                                    </Button>
                                    <Button
                                        variant={openPdfUploader ? 'contained' : 'outlined'}
                                        startIcon={<FiFile size={16} />}
                                        onClick={() => {
                                            setOpenPdfUploader(!openPdfUploader);
                                            setOpenImageUploader(false);
                                            if (!openPdfUploader && !postPdfs.length) {
                                                setTimeout(() => pdfInput.current?.click(), 100);
                                            }
                                        }}
                                        sx={{
                                            textTransform: 'none',
                                            fontSize: '0.875rem',
                                            borderRadius: '8px'
                                        }}
                                    >
                                        Documents
                                    </Button>
                                </Box>
                            </Box>

                            {/* Media Upload Sections */}
                            <Box sx={{ mb: 3 }}>
                                {/* Images/Videos */}
                                {(openImageUploader ||
                                    postImages.length > 0 ||
                                    (Array.isArray(existingpostImages) && existingpostImages.length > 0) ||
                                    (Array.isArray(existingpostVideos) && existingpostVideos.length > 0)) && (
                                    <Box sx={{ mb: 3 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                            Photos & Videos
                                        </Typography>

                                        {/* Existing Images */}
                                        {Array.isArray(existingpostImages) && existingpostImages.length > 0 && (
                                            <Box sx={{ mb: 2 }}>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                                    Existing Images
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: 'grid',
                                                        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                                        gap: 2
                                                    }}
                                                >
                                                    {existingpostImages.map((image, index) => (
                                                        <Box
                                                            key={`existing-img-${index}`}
                                                            sx={{
                                                                position: 'relative',
                                                                borderRadius: '8px',
                                                                overflow: 'hidden',
                                                                backgroundColor: '#F8FAFC',
                                                                border: '1px solid #E2E8F0',
                                                                '&:hover .delete-button': {
                                                                    opacity: 1
                                                                }
                                                            }}
                                                        >
                                                            <img
                                                                src={`${process.env.REACT_APP_BACKEND_URL}/Uploads/${notice.company_id}/Notice/${notice.notice_id}/${image}`}
                                                                alt="existing"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '150px',
                                                                    objectFit: 'cover'
                                                                }}
                                                            />
                                                            <IconButton
                                                                className="delete-button"
                                                                onClick={() => {
                                                                    setExistingPostImages((prev) => prev.filter((_, i) => i !== index));
                                                                }}
                                                                sx={{
                                                                    position: 'absolute',
                                                                    top: 4,
                                                                    right: 4,
                                                                    opacity: 0,
                                                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                                    color: 'error.main',
                                                                    '&:hover': { backgroundColor: 'error.lighter' },
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                            >
                                                                <FiTrash2 size={16} />
                                                            </IconButton>
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}

                                        {/* Existing Videos */}
                                        {Array.isArray(existingpostVideos) && existingpostVideos.length > 0 && (
                                            <Box sx={{ mb: 2 }}>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                                    Existing Videos
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: 'grid',
                                                        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                                        gap: 2
                                                    }}
                                                >
                                                    {existingpostVideos.map((video, index) => (
                                                        <Box
                                                            key={`existing-video-${index}`}
                                                            sx={{
                                                                position: 'relative',
                                                                borderRadius: '8px',
                                                                overflow: 'hidden',
                                                                backgroundColor: '#F8FAFC',
                                                                border: '1px solid #E2E8F0',
                                                                '&:hover .delete-button': {
                                                                    opacity: 1
                                                                }
                                                            }}
                                                        >
                                                            <video
                                                                src={`${process.env.REACT_APP_BACKEND_URL}/Uploads/notice/${notice.company_id}/${notice.entry_id}/${video}`}
                                                                controls
                                                                style={{
                                                                    width: '100%',
                                                                    height: '150px',
                                                                    objectFit: 'cover'
                                                                }}
                                                            />
                                                            <IconButton
                                                                className="delete-button"
                                                                onClick={() => {
                                                                    setExistingPostVideos((prev) => prev.filter((_, i) => i !== index));
                                                                }}
                                                                sx={{
                                                                    position: 'absolute',
                                                                    top: 4,
                                                                    right: 4,
                                                                    opacity: 0,
                                                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                                    color: 'error.main',
                                                                    '&:hover': { backgroundColor: 'error.lighter' },
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                            >
                                                                <FiTrash2 size={16} />
                                                            </IconButton>
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}

                                        {/* New Images/Videos */}
                                        {postImages.length > 0 ? (
                                            <Box sx={{ mb: 2 }}>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                                    New Files
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: 'grid',
                                                        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                                        gap: 2,
                                                        mb: 2
                                                    }}
                                                >
                                                    {postImages.map((image, index) => (
                                                        <Box
                                                            key={`new-img-${index}`}
                                                            sx={{
                                                                position: 'relative',
                                                                borderRadius: '8px',
                                                                overflow: 'hidden',
                                                                backgroundColor: '#F8FAFC',
                                                                border: '1px solid #E2E8F0',
                                                                '&:hover .delete-button': {
                                                                    opacity: 1
                                                                }
                                                            }}
                                                        >
                                                            {postMediaData[index]?.split(';base64')[0].split(':')[1].split('/')[0] ===
                                                            'image' ? (
                                                                <img
                                                                    src={image}
                                                                    alt="uploaded"
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '150px',
                                                                        objectFit: 'cover'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <video
                                                                    src={image}
                                                                    controls
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '150px',
                                                                        objectFit: 'cover'
                                                                    }}
                                                                />
                                                            )}
                                                            <IconButton
                                                                className="delete-button"
                                                                onClick={() => {
                                                                    setPostImages((prev) => prev.filter((_, i) => i !== index));
                                                                    setPostMediaData((prev) => prev.filter((_, i) => i !== index));
                                                                    setPostMediaFile((prev) => prev.filter((_, i) => i !== index));
                                                                }}
                                                                sx={{
                                                                    position: 'absolute',
                                                                    top: 4,
                                                                    right: 4,
                                                                    opacity: 0,
                                                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                                    color: 'error.main',
                                                                    '&:hover': { backgroundColor: 'error.lighter' },
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                            >
                                                                <FiTrash2 size={16} />
                                                            </IconButton>
                                                        </Box>
                                                    ))}
                                                </Box>
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<FiPlus size={16} />}
                                                    onClick={() => imageInput.current?.click()}
                                                    sx={{ textTransform: 'none', borderRadius: '8px' }}
                                                >
                                                    Add More Photos/Videos
                                                </Button>
                                            </Box>
                                        ) : (
                                            <Box
                                                onClick={() => imageInput.current?.click()}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    p: 4,
                                                    borderRadius: '8px',
                                                    backgroundColor: '#F8FAFC',
                                                    border: '1px dashed #CBD5E1',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        backgroundColor: '#F1F5F9',
                                                        borderColor: '#94A3B8'
                                                    },
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <RiUploadCloud2Line size={32} color={theme.palette.primary.main} />
                                                <Typography color="primary" sx={{ mt: 1, fontWeight: 500 }}>
                                                    Click to upload photos or videos
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                )}

                                {/* Documents */}
                                {(openPdfUploader || postPdfs.length > 0 || (Array.isArray(existingFiles) && existingFiles.length > 0)) && (
                                    <Box sx={{ mb: 3 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                            Documents
                                        </Typography>

                                        {/* Existing Documents */}
                                        {Array.isArray(existingFiles) && existingFiles.length > 0 && (
                                            <Box sx={{ mb: 2 }}>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                                    Existing Documents
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                    {existingFiles.map((file, index) => (
                                                        <Box
                                                            key={`existing-file-${index}`}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                p: 2,
                                                                borderRadius: '8px',
                                                                backgroundColor: '#F8FAFC',
                                                                border: '1px solid #E2E8F0',
                                                                '&:hover': {
                                                                    backgroundColor: '#F1F5F9',
                                                                    borderColor: '#CBD5E1'
                                                                },
                                                                transition: 'all 0.2s ease'
                                                            }}
                                                        >
                                                            <FiFile size={20} color={theme.palette.primary.main} />
                                                            <Typography
                                                                sx={{
                                                                    ml: 2,
                                                                    flex: 1,
                                                                    fontSize: '0.875rem',
                                                                    cursor: 'pointer',
                                                                    '&:hover': { color: 'primary.main' }
                                                                }}
                                                                onClick={() => {
                                                                    window.open(
                                                                        `${process.env.REACT_APP_BACKEND_URL}/Uploads/${notice.company_id}/Notice/${notice.notice_id}/${file}`,
                                                                        '_blank'
                                                                    );
                                                                }}
                                                            >
                                                                {file}
                                                            </Typography>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => {
                                                                    setExistingFiles((prev) => prev.filter((_, i) => i !== index));
                                                                }}
                                                                sx={{
                                                                    color: 'text.secondary',
                                                                    '&:hover': { color: 'error.main' }
                                                                }}
                                                            >
                                                                <FiTrash2 size={16} />
                                                            </IconButton>
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}

                                        {/* New Documents */}
                                        {postPdfs.length > 0 ? (
                                            <Box sx={{ mb: 2 }}>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                                    New Documents
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                                                    {postPdfs.map((pdf, index) => (
                                                        <Box
                                                            key={`new-pdf-${index}`}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                p: 2,
                                                                borderRadius: '8px',
                                                                backgroundColor: '#F8FAFC',
                                                                border: '1px solid #E2E8F0',
                                                                '&:hover': {
                                                                    backgroundColor: '#F1F5F9',
                                                                    borderColor: '#CBD5E1'
                                                                },
                                                                transition: 'all 0.2s ease'
                                                            }}
                                                        >
                                                            <FiFile size={20} color={theme.palette.primary.main} />
                                                            <Typography
                                                                sx={{
                                                                    ml: 2,
                                                                    flex: 1,
                                                                    fontSize: '0.875rem',
                                                                    cursor: 'pointer',
                                                                    '&:hover': { color: 'primary.main' }
                                                                }}
                                                                onClick={() => window.open(pdf, '_blank')}
                                                            >
                                                                {postPdfNames[index]}
                                                            </Typography>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => {
                                                                    setPostPdfs((prev) => prev.filter((_, i) => i !== index));
                                                                    setPostPdfNames((prev) => prev.filter((_, i) => i !== index));
                                                                    setPostPdfsData((prev) => prev.filter((_, i) => i !== index));
                                                                }}
                                                                sx={{
                                                                    color: 'text.secondary',
                                                                    '&:hover': { color: 'error.main' }
                                                                }}
                                                            >
                                                                <FiTrash2 size={16} />
                                                            </IconButton>
                                                        </Box>
                                                    ))}
                                                </Box>
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<FiPlus size={16} />}
                                                    onClick={() => pdfInput.current?.click()}
                                                    sx={{ textTransform: 'none', borderRadius: '8px' }}
                                                >
                                                    Add More Documents
                                                </Button>
                                            </Box>
                                        ) : (
                                            <Box
                                                onClick={() => pdfInput.current?.click()}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    p: 4,
                                                    borderRadius: '8px',
                                                    backgroundColor: '#F8FAFC',
                                                    border: '1px dashed #CBD5E1',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        backgroundColor: '#F1F5F9',
                                                        borderColor: '#94A3B8'
                                                    },
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <FiFile size={32} color={theme.palette.primary.main} />
                                                <Typography color="primary" sx={{ mt: 1, fontWeight: 500 }}>
                                                    Click to upload documents
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                )}
                            </Box>

                            {/* Submit Button */}
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    variant="contained"
                                    onClick={submitPost}
                                    disabled={processing}
                                    sx={{
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                        fontSize: '1rem',
                                        fontWeight: 600
                                    }}
                                >
                                    {processing ? 'Processing...' : notice ? 'Update Notice' : 'Announce Notice'}
                                </Button>
                            </Box>

                            {/* Hidden file inputs */}
                            <input
                                ref={imageInput}
                                type="file"
                                accept="image/*,video/*"
                                onChange={convertMedia}
                                style={{ display: 'none' }}
                                multiple
                            />
                            <input
                                ref={pdfInput}
                                type="file"
                                accept=".pdf,.xlsx,.doc,.docx"
                                onChange={convertPdf}
                                style={{ display: 'none' }}
                                multiple
                            />
                        </CardContent>
                    </Card>
                ) : operation === 'delete' ? (
                    <Card
                        sx={{
                            width: { xs: '95%', md: '400px' },
                            position: 'relative',
                            borderRadius: '12px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                            backgroundColor: 'white'
                        }}
                    >
                        <CardContent sx={{ p: 3 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                <Typography variant="h6" color="error" sx={{ fontWeight: 600 }}>
                                    Delete Notice
                                </Typography>
                                <IconButton
                                    onClick={handleClose}
                                    sx={{
                                        color: 'text.secondary',
                                        bgcolor: 'grey.100',
                                        borderRadius: '50%',
                                        '&:hover': { bgcolor: 'grey.300' }
                                    }}
                                >
                                    <FiX size={18} />
                                </IconButton>
                            </Box>

                            <Typography variant="body1" sx={{ mb: 3 }}>
                                Are you sure you want to delete this notice? This action cannot be undone.
                            </Typography>

                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Button
                                    variant="outlined"
                                    onClick={handleClose}
                                    disabled={processing}
                                    sx={{
                                        flex: 1,
                                        borderRadius: '8px',
                                        textTransform: 'none'
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={destroyNotice}
                                    disabled={processing}
                                    sx={{
                                        flex: 1,
                                        borderRadius: '8px',
                                        textTransform: 'none'
                                    }}
                                >
                                    {processing ? 'Deleting...' : 'Delete'}
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                ) : null}
            </Box>
        </Modal>
    );
};

export default Notice;
